import { render, staticRenderFns } from "./SupportButton.vue?vue&type=template&id=42a79e3a&scoped=true"
import script from "./SupportButton.vue?vue&type=script&lang=js"
export * from "./SupportButton.vue?vue&type=script&lang=js"
import style0 from "./SupportButton.vue?vue&type=style&index=0&id=42a79e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a79e3a",
  null
  
)

export default component.exports